import { InstitutionGroups } from './list'
import { InstitutionGroupDetail } from './detail'

export { InstitutionGroups, InstitutionGroupDetail }



// WEBPACK FOOTER //
// ./src/internal-app/pages/institutionGroups/index.js